var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-wrapper"},[_c('font-awesome-icon',{staticClass:"loading-spinner fa-spin fa-3x",attrs:{"icon":['fad', 'circle-notch']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }